var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBrandRakuten = function SvgBrandRakuten(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "be5b2203-aeb3-4b01-bb24-7224f0497dbf",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M743,600.4H267.3l37.9,37.9Zm76.4-24.2V500.3c0-14.2,9.9-26.1,24.2-26.1s24.2,11.9,24.2,26.1v75.9h29.4V500.3c0-31.3-21.4-56.5-52.7-56.5-14.2,0-25.1,8.1-25.1,8.1v-5.2H790v129h29.4ZM722.1,443.4c-34.1,0-58.3,29.8-58.3,67.8,0,39.8,30.4,67.8,61.2,67.8,15.6,0,35.1-5.2,51.7-28.9l-26.1-15.2c-19.9,29.4-53.6,14.7-57.4-15.2h84.4c7.6-45.5-22.3-76.3-55.5-76.3Zm25.7,51.2H695.1C701.3,464.7,742.1,462.8,747.8,494.6Z",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.3,545.3a17.9,17.9,0,0,1-9.9,3.4c-4.8,0-13.8-3.8-13.8-15.7V477.5h25.1V446.7H630.6V414.4H601.2v32.3H585.5v30.8h15.7V533c0,28.9,21.8,46,43.6,46,8.1,0,19.5-2.8,28.5-8ZM546.2,446.7v75.9c0,14.2-10,26.1-24.2,26.1s-24.2-11.9-24.2-26.1V446.7H468.4v75.9c0,31.3,21.3,56.4,52.6,56.4,14.3,0,25.2-8,25.2-8v4.7h29.4v-129Z",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.4,507.4l50.2-60.7H422.8l-35.5,45V404H357.4V576.2h29.9V523.1l43.6,53.1h40.8Zm-102-60.7v5.7c-9-5.7-16.6-9-27.5-9-33.2,0-58.8,30.3-58.8,67.8S250.2,579,283.9,579c10.9,0,19-3.3,27.5-9v5.7h29.4v-129Zm-28,101.5c-16.6,0-28.5-16.1-28.5-36.5s11.9-36.6,28.5-36.6,28,16.2,28,36.6-11.4,36.5-28,36.5Z",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,576.2V525.9H162l37.5,49.8h38.4l-45.6-60.2a55.1,55.1,0,0,0,23.3-45.6,55.6,55.6,0,0,0-55.5-55.5H109.8V575.7h30.8Zm0-130.9h20a25.1,25.1,0,1,1,0,50.2h-20Z",
    fill: "#183149"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e9b97b58-516d-475c-bfd1-eb650312988d",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrandRakuten, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brand-rakuten.85876bbb.svg";
export { ForwardRef as ReactComponent };